import api from "../interceptors/axios";

export const tutorialDetail = async (id) => {
  try {
    const response = await api.get(`api/v1/tutorials`, {
      params: {
        showOnSetting: false,
        brands: id,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};
